import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";
import useStyles from "./useStyles";
import {memo, useMemo} from "react";
import s from "../ReportBody/docs.module.css";

const VisitsTable = (props) => {
  const classes = useStyles();
  const {
    data,
    /**признак того что таблица стриться для трекера (куда шлялся) - если ложь то по геозонам (кто приперался) */
    byTracker = true,
  } = props;

  const columns = useMemo(
      () => [
        {
          accessorKey: 'tracker.value', //access nested data with dot notation
          header: byTracker ? "Геозона" : "Трекер",
        },
        {
          accessorKey: 'start.value',
          header: 'Время захода',
        },
        {
          accessorKey: 'end.value', //normal accessorKey
          header: 'Время выхода',
        },
        {
          accessorKey: 'duration.value',
          header: 'Продолжительность нахождения',
        },
      ],
      [])

  return (
    <>
      <div className={classes.tableContainer}>
        <Typography sx={{paddingLeft: "10px"}} gutterBottom className={classes.tableTitle}>Пересечения границ геозон</Typography>
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "rgba(104, 154, 219, 0.2)" }}>
              <TableRow>

                {columns.map((column, index) => (
                    <TableCell className={`${index > 0 ? classes.textAlignRight : ''} ${classes.tableHeader}`}>{column.header}</TableCell>
                ))}

              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(({ geozone, tracker, start, end, duration }, i) => (
                <TableRow key={i}>
                  <TableCell
                      key="geozoneOrTracker"
                      className={classes.tableBody}
                  >
                    {byTracker ? geozone?.value : tracker?.value}
                  </TableCell>
                  <TableCell  className={`${classes.textAlignRight}  ${classes.tableBody}`} key="start">{start?.value}</TableCell>
                  <TableCell  className={`${classes.textAlignRight}  ${classes.tableBody}`} key="end">{end?.value}</TableCell>
                  <TableCell  className={`${classes.textAlignRight}  ${classes.tableBody}`} key="duration">{duration?.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default memo(VisitsTable);
